import "@ceridianhcm/components/dist/index.css"; 
import "@ceridianhcm/theme/dist/theme.css"; 
import "./styles/index.scss";
import React, { Suspense, useState, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ErrorBoundary, useErrorBoundary } from "react-error-boundary";
import { Authorizing } from './components/Authorizing/Authorizing';
import { StandAloneProvider } from "./common/components/context/StandAloneContext";
import { UnAuthorized } from "./components/UnAuthorized/Unauthorized";
import { authenticate } from "./services/ImportDetailService";
import PagenavigatorComponent from "./PageNavigator";
import YearEndProcessing from "./components/YearEndProcessing/YearEndProcessing";
import PayrollSummary from "./components/PayrollSummary/PayrollSummary";
import { createAppInsightsClient } from './appInsights';

const client = createAppInsightsClient();

export function handleErrorBoundary(error: Error) {
  client.trackTrace({
    message: 'UI_RENDER_ERROR',
    severityLevel: 2,
    properties: {
      name: error?.name ?? 'UnknownError'
    }
  });
}

export function ErrorFallback() {
  const { resetBoundary } = useErrorBoundary();

  return (
    <div role="alert">
      <p>Something went wrong.</p>
      <button onClick={resetBoundary}>Try again</button>
    </div>
  );
}

export const App: React.FC = () => {

    const [isAuthenticated, setisAuthenticated] = useState(false);
    const [showUnAuth, setShowUnAuth] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        async function authenticateUser() {
            try {
                const resp = await authenticate();
                setisAuthenticated(resp);
                setShowUnAuth(!resp);   
                setLoading(false);
            } catch (error) {
                setisAuthenticated(false);
                setShowUnAuth(true);
                setLoading(false);
                return new Error(error)   
            }                                     
        };

        authenticateUser();
    }, []);

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleErrorBoundary}>
            <StandAloneProvider>
                <Router>
                    <Routes>
                        {loading ?
                            <Route path="/" element={<Authorizing />} />
                            :
                            isAuthenticated  ? 
                                <>
                                    <Route path="/" element={<PagenavigatorComponent />} />
                                    <Route path="/yearend" element={<YearEndProcessing />} />
                                    <Route path="/payroll" element={<PayrollSummary />} />
                                </>
                            : showUnAuth &&  
                                <>
                                    <Route path="/" element={<UnAuthorized />} />
                                </>      
                            
                        }
                    </Routes>
                </Router>
            </StandAloneProvider>
        </ErrorBoundary>
    );
};